
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(48(14|42)|1160|2775|6233|7080|8614)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
